/**
 * Registr Window → Phoenix layerId pro legacy form iframy.
 *
 * Když Phoenix otevře legacy agendu, ShellPage namountuje iframe. Po načtení iframu
 * (`onLoad`) si zaregistrujeme jeho `contentWindow → layerId` mapping. Když pak Magic
 * z toho iframu pošle `form/result`, bridge si podle `event.source` najde příslušný
 * layerId a uzavře tu agendu (ne libovolnou top-level).
 *
 * Mapování je v paměti, klíč je `Window` reference — drží se jen dokud existuje iframe.
 */
const map = new WeakMap<Window, string>();
const reverseMap = new Map<string, Window>();

export const legacyFormSourceRegistry = {
  register(source: Window, layerId: string): void {
    map.set(source, layerId);
    reverseMap.set(layerId, source);
  },
  unregister(layerId: string): void {
    const src = reverseMap.get(layerId);
    if (src) {
      map.delete(src);
      reverseMap.delete(layerId);
    }
  },
  resolveLayerId(source: Window): string | undefined {
    return map.get(source);
  },
  resolveWindow(layerId: string): Window | undefined {
    return reverseMap.get(layerId);
  },
};
